import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { Portal } from 'react-portal';
import classnames from 'classnames';
import withBoundingClientRect from '../../common/hoc/withBoundingClientRect';

const TOOLTIP_OFFSET = { x: 40, y: -30 };

const NavTooltip = ({ boundingClientRect, active, ...props }) => (
  <div>
    <Portal>
      <div
        className={classnames('c-info-nav-tooltip__content', { 'is-active': active })}
        style={{
          position: 'fixed',
          left: (boundingClientRect.left || 0) + TOOLTIP_OFFSET.x,
          top: (boundingClientRect.top || 0) + TOOLTIP_OFFSET.y,
          zIndex: 999,
        }}
        {...props}
      />
    </Portal>
  </div>
);

NavTooltip.propTypes = {
  boundingClientRect: PropTypes.object.isRequired,
  active: PropTypes.bool.isRequired,
};

export default compose(withBoundingClientRect)(NavTooltip);
